module.exports = __webpack_public_path__ + "static/img/mascot-betask-3.2c188e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mascot-betask-3.png
// module id = rQgf
// module chunks = 3